import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import { site, trustStats } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-primary-950 pt-28 md:pt-36">
      <div className="pointer-events-none absolute inset-0 grid-paper opacity-[0.08]" aria-hidden="true" />
      <div
        className="pointer-events-none absolute -right-20 -top-24 h-[30rem] w-[30rem] rounded-full bg-primary-700/40 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-24 top-1/2 h-80 w-80 rounded-full bg-accent-500/10 blur-3xl"
        aria-hidden="true"
      />

      <div className="shell relative pb-16 md:pb-24">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/5 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-accent-300">
                <i className="ri-map-pin-line text-sm" aria-hidden="true" />
                {site.district}
              </span>
            </Reveal>

            <Reveal delay={80}>
              <h1 className="mt-7 font-heading text-[2.6rem] font-semibold leading-[0.98] tracking-tight text-background-50 sm:text-5xl lg:text-[4.1rem]">
                Diş hekiminizin istediği
                <br className="hidden sm:block" /> görüntüyü{" "}
                <span className="relative isolate whitespace-nowrap text-accent-400">
                  aynı gün
                  <span
                    className="absolute inset-x-0 -bottom-1 h-[3px] rounded-full bg-accent-400/70"
                    aria-hidden="true"
                  />
                </span>{" "}
                çektirin.
              </h1>
            </Reveal>

            <Reveal delay={140}>
              <p className="mt-7 max-w-xl text-base leading-relaxed text-background-200/80 md:text-lg">
                Panoramik röntgen, 3D dental tomografi (CBCT), sefalometrik, TME (çene eklemi),
                el-bilek ve bite-wing dahil tüm çekimler — 2026 model CBCT cihazımızla, düşük doz ve
                dijital rapor ile. İstanbul'un merkezinde, diş hekimlerinin güvendiği görüntüleme
                merkezi.
              </p>
            </Reveal>

            <Reveal delay={200}>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Button href={site.whatsapp} external variant="accent" size="lg" icon="ri-whatsapp-line">
                  WhatsApp'tan Randevu Al
                </Button>
                <Button href={site.phoneMainHref} variant="outlineLight" size="lg" icon="ri-phone-line">
                  Hemen Ara
                </Button>
              </div>
            </Reveal>

            <Reveal delay={260}>
              <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-background-50/15 pt-8 sm:grid-cols-4">
                {trustStats.map((stat) => (
                  <div key={stat.label}>
                    <dt className="font-heading text-2xl font-semibold text-background-50 md:text-[1.75rem]">
                      {stat.value}
                    </dt>
                    <dd className="mt-1 text-xs font-medium uppercase tracking-wide text-background-200/70">
                      {stat.label}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>

          <Reveal delay={120} className="lg:col-span-5">
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg border border-background-50/15 bg-foreground-950">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20panoramic%20dental%20x-ray%20radiograph%20of%20a%20full%20adult%20jaw%20with%20all%20teeth%20clearly%20visible%2C%20soft%20mint%20green%20glow%20on%20a%20deep%20charcoal%20background%2C%20high%20detail%20medical%20imaging%2C%20minimal%20scientific%20composition%2C%20elegant%20clinical%20aesthetic%2C%20no%20text%2C%20no%20people&width=900&height=1200&seq=dmar-hero-radiograph&orientation=portrait"
                  alt="Panoramik dental röntgen görüntüsü — d.mar Dental Görüntüleme Merkezi"
                  title="Panoramik dental röntgen — d.mar Dental Görüntüleme Merkezi"
                  className="h-[400px] w-full object-cover object-top sm:h-[480px] lg:h-[580px]"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"
                  aria-hidden="true"
                />
                <div className="absolute inset-x-5 bottom-5">
                  <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-accent-300">
                    2026 model CBCT
                  </p>
                  <p className="mt-1 font-heading text-base text-background-50">
                    En güncel 3D dental görüntüleme teknolojisi
                  </p>
                </div>
              </div>

              <div className="absolute -left-3 -top-3 hidden h-10 w-10 rounded-tl-lg border-l-2 border-t-2 border-accent-400 sm:block" aria-hidden="true" />
              <div className="absolute -bottom-3 -right-3 hidden h-10 w-10 rounded-br-lg border-b-2 border-r-2 border-accent-400 sm:block" aria-hidden="true" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}